<template>
  <main role="main">
    <div class="container">
      <div class="row">
        <div class="col-md-7">
          <article class="card">
            <video
              style="width: 100%; height: auto"
              autoplay="autoplay"
              loop
              id="vid-size"
              muted
              playsinline
              webkit-playsinline
              preload="auto"
            >
              <source src="/docs/assets/img/memphisme.webm" type="video/webm" />
              <source src="/docs/assets/img/memphisme.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>

            <a href="/">
              <div class="card-body">
                <h1 class="card-title display-4">Software Engineer</h1>
                <p>
                  Hi, I'm Michael Beard, a backend and full-stack software engineer with experience building production
                  systems using Ruby on Rails, React, Redux, PostgreSQL, and Apache Kafka.
                  <br />
                  <br />

                  Most recently, I worked as a Software Engineer at Booz Allen Hamilton on the VA Caseflow platform,
                  building and maintaining applications that support complex appeals workflows. My work included backend
                  feature development, API integrations, test coverage improvements, performance optimization, bug
                  reduction, and user-facing features built with React and Redux.
                  <br />
                  <br />

                  I enjoy working on systems with real-world complexity: workflow engines, data-heavy applications,
                  service integrations, and tools that help users move through complicated processes more efficiently.
                  <br />
                  <br />

                  Before software engineering, my background spanned design, video production, small business
                  operations, and agriculture. That path shaped how I work today: I bring strong communication, creative
                  problem-solving, attention to detail, and a practical sense of how software supports real people doing
                  real work.
                  <br />
                  <br />

                  I'm currently looking for backend and full-stack engineering opportunities where I can contribute to
                  scalable systems, clean architecture, strong testing practices, and thoughtful user experiences.
                </p>
              </div>
            </a>
          </article>
        </div>
      </div>
    </div>
  </main>

  <footer class="footer pt-5 pb-5 text-center"></footer>
</template>

<script>
export default {
  data: function () {
    return {};
  },
  created: function () {},
  methods: {},
  // mounted: function () {
  //   this.$refs.videoRef.src = "/docs/assets/img/memphisme.mp4";
  //   this.$refs.videoRef.play();
  // },
};
</script>

<style scoped>
.row {
  margin: auto;
  justify-content: center;
}
</style>
